import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { getInstitutionLabel, isSemar } from '../config/institutions';
import '../styles/Bibliografia.css';

const Bibliografia = () => {
  const { institucion } = useAuth();
  const semar = isSemar(institucion);
  const handleRamasClick = () => {
    window.open('https://www.mediafire.com/folder/9ol5apjuoje2u/CONOCIMIENTOS+ESPECIFICOS', '_blank');
  };
  const handleLegislacionClick = () => {
    window.open('https://www.mediafire.com/folder/8b3h6lxwps8g7/LEYES+Y+REGLAMENTOS', '_blank');
  };
  const handleMarinerosClick = () => {
    window.open('https://www.mediafire.com/folder/z23qxe1rvewo4/CONOCIMIENTOS_MARINEROS', '_blank');
  };
  if (!semar) {
    return (
      <div className="quiz-selection-container" style={{ maxWidth: '100%', margin: 0, height: 'calc(100vh - 60px)', boxSizing: 'border-box', overflowY: 'auto' }}>
        <div className="bibliografia-header">
          <h1>Biblioteca de Consulta</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', marginTop: '10px' }}>
            Repositorio documental para el personal de {getInstitutionLabel(institucion)}
          </p>
        </div>
        <div className="quiz-grid" style={{ marginTop: '2rem' }}>
          <div className="area-card" style={{ cursor: 'default' }}>
            <div className="area-content">
              <div className="area-icon">📚</div>
              <h3>Bibliografía en preparación</h3>
              <div className="area-stats">Próximamente</div>
              <p>
                Estamos integrando el repositorio documental de tu institución. Puedes continuar
                con los cuestionarios y el simulador mientras se publica.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-selection-container" style={{ maxWidth: '100%', margin: 0, height: 'calc(100vh - 60px)', boxSizing: 'border-box', overflowY: 'auto' }}>
      <div className="bibliografia-header">
        <h1>Biblioteca de Consulta</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', marginTop: '10px' }}>
          Repositorio técnico oficial para el personal de la Armada de México
        </p>
      </div>

      <div className="quiz-grid" style={{ marginTop: '2rem' }}>
        <div className="area-card" role="button" tabIndex={0} onClick={handleRamasClick} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleRamasClick(); } }}>
          <div className="area-content">
            <div className="area-icon">⚓</div>
            <h3>Conocimientos Específicos</h3>
            <div className="area-stats">Repositorio Digital</div>
            <p>Accede al material de estudio de las diferentes ramas y servicios de la Armada.</p>
          </div>
        </div>

        <div className="area-card" onClick={handleLegislacionClick}>
          <div className="area-content">
            <div className="area-icon">📜</div>
            <h3>Legislación Naval</h3>
            <div className="area-stats">Leyes y Reglamentos</div>
            <p>Consulta las leyes y reglamentos navales vigentes para tu ascenso.</p>
          </div>
        </div>

        <div className="area-card" onClick={handleMarinerosClick}>
          <div className="area-content">
            <div className="area-icon">🚢</div>
            <h3>Conocimientos Marineros</h3>
            <div className="area-stats">Manuales Técnicos</div>
            <p>Consulta el libro de Barbudo Duarte y otras publicaciones operativas principales.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bibliografia;